export default {
    activateuser: {
        headerLabel: 'Assunzione utente',
        accountActivation: 'Attivazione account',
        step1: {
            header: 'Benvenuto sulla nostra piattaforma!',
            subHeader: 'Scegli come vuoi connetterti al tuo account',
            description:
                'Per un processo di login più semplice, ti consigliamo di collegare il tuo account ad almeno uno dei seguenti servizi.',
            OR: 'oppure',
            emailAndPassword: 'Usa la tua email',
        },
        step2: {
            header: 'Usa email e password',
            description:
                "Questa è l'email principale che sarà associata al tuo account. Ti consigliamo di usare un'email diversa dal tuo indirizzo dell'università in modo da mantenere l'accesso ai tuoi dati dopo la laurea. Puoi facilmente controllare quali email riceverai da noi nelle impostazioni del tuo account.",
            invalidEmail: 'L’email fornita non è valida',
            passwordsNotMatch: 'La password deve essere uguale',
            passwordDescription01:
                'Per garantire la sicurezza del tuo account è necessario impostare una nuova password. Si prega di creare una password con le seguenti caratteristiche:',
            passwordDescription02: 'Minimo di 8 caratteri',
            passwordDescription03: 'Almeno una lettera minuscola (a-z)',
            passwordDescription04: 'Almeno una lettera maiuscola (A-Z)',
            passwordDescription05: 'Almeno un numero o un carattere speciale (0-9, !#$ etc)',
            passwordDescription06: 'Almeno 6 caratteri diversi',
            repeatPassword: 'Digita nuovamente la password',
        },
        step3: {
            header: 'Attivazione utente',
            loadingHints: {
                '0': 'Caricamento dati utente',
                '1': 'Stiamo preparando tutto',
                '2': 'Nuove opportunità dietro l’angolo',
                '3': 'Quasi finito!',
            },
            successHeader: 'Ora il tuo account è pronto!',
            successSubheader: 'Adesso hai accetto a contenuti esclusivi!',
            errorHeader: 'Non è stato possibile attivare il tuo account',
            ifWrongContact: 'Se pensi ci sia un errore, contatta il servizio clienti',
            contactForHelp: 'Contattaci se ti serve aiuto',
            goBack: 'Indietro',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Controlla il mio progresso',
            getStarted: 'Inizia!',
            getToKnowYourself: 'Conosci te stesso',
            getToKnowYourselfBold: 'Conosci <strong>te stesso</strong>',
            getToKnowYourFuture: 'Conosci il tuo futuro',
            getToKnowYourFutureBold: 'Conosci <strong>il tuo futuro</strong>',
            openAssessments: 'Apri le valutazioni',
            openAssessment: 'Apri la valutazione',
            unlock: 'Sblocca i test',
            testYourself: 'Mettiti alla prova',
            takeTheFreeTests: 'Fai i test gratuiti',
            youOwnThisProduct: 'Possiedi questo prodotto',
            startTest: 'Inizia il test',
            startTests: 'Inizia i test',
            continue: 'Continua',
            showReport: 'Mostra resoconto',
            showYourReports: 'Mostra i tuoi resoconti',
            showYourReport: 'Mostra il tuo resoconto',
            continueFreeTests: 'Continua i test gratuiti',
            continueTheTest: 'Continua i test',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Mettiti alla prova',
                description01:
                    'Benvenuto al Centro Valutazioni - è qui che inizia il percorso della tua carriera.',
                description02:
                    'Qui è dove puoi fare <strong>i test di valutazione Aon</strong> usati dai reclutatori di tutto il mondo, che verificano la tua capacità e predisposizione per una futura carriera.',
                freemium: {
                    description:
                        'Fai questi test per misurare i tuoi punti di forza e ottenere resoconti validi sulle tue capacità.',
                    price: 'Gratuiti',
                    numTests: '3 test',
                    timeEstimated: 'Approssimativamente 27 min.',
                },
                premium: {
                    description:
                        'Questo è un <strong>vero affare</strong>. Fai questo test 3 in 1 per scoprire quali percorsi di carriera dovresti seguire e ricevi un resoconto completo per la tua candidatura.',
                    numTests: 'Test 3 in 1',
                    timeEstimated: 'Approssimativamente 60 min.',
                    sampleReport: 'Scarica un esempio di resoconto',
                    candidateReport: 'Resoconto del Candidato',
                    candidateReportDescription:
                        'Una volta terminati questi test, riceverai un resoconto completo del candidato con una descrizione esauriente dei tuoi risultati, compresi consigli su come migliorare le tue abilità personali, a quali competenze dovresti prestare attenzione, quali sono le migliori opportunità per iniziare, quale dovrebbe essere il tuo prossimo passo e altro ancora.',
                },
            },
            section2: {
                title: 'Come questi test possono aiutarti a trovare un lavoro?',
                t1: 'Sarai consapevole delle tue <strong>abilità</strong>',
                t2: 'Ti renderai conto del tuo <strong>potenziale</strong>',
                t3: 'Ti sarà indicato un chiaro <strong>percorso di carriera</strong>',
                t4: 'Aumenterà <strong>la fiducia in te stesso</strong>',
            },
            section3: {
                title:
                    'Scopri i tuoi punti di forza personali e le opportunità di carriera per indirizzare il tuo progresso e la tua carriera.',
            },
            section4: {
                title: 'Avvantaggiati sui tuoi concorrenti oggi',
                description:
                    'completando le valutazioni utilizzate dai reclutatori di tutto il mondo in aziende come Deloitte, Siemens, Burger King, Vodafone o P&G.',
            },
            section5: {
                title: 'Domande frequenti',
                thisPage: 'questa pagina',
                question01: {
                    q: 'Cosa sono i test di valutazione Aon?',
                    a:
                        "Le valutazioni del talento di Aon sono test riconosciuti a livello mondiale che aiutano le aziende di tutto il mondo a identificare i migliori candidati per un lavoro. Con l'aiuto delle valutazioni del talento i reclutatori possono guardare oltre i CV, i voti scolastici, i certificati universitari e gli attestati.",
                },
                question02: {
                    q: 'Devo pagare per fare queste valutazioni?',
                    a:
                        "Puoi fare 4 di questi test gratuitamente - <i>Comportamento legato al lavoro</i>, <i>Ragionamento numerico</i>, <i>Pensiero logico-deduttivo</i> e <i>Ragionamento logico-induttivo</i>. Questi test misurano le tue abilità e attitudini e sono un ottimo modo per scoprire i tuoi punti di forza e di debolezza.\n\n <br><br>Tuttavia, se vuoi avere una panoramica completa delle tue predisposizioni, ricevere approfondimenti professionali sui tuoi percorsi di carriera più adatti e fare un grande passo verso il tuo futuro successo, puoi anche accedere al test 3-in-1 e ottenere un Resoconto del candidato<br>bompleto per €79. <br><br>Per l'accesso avanzato, basta <a href={premiumLink}>cliccare qui</a> e pagare con carta - stiamo usando un metodo di pagamento sicuro.                ",
                },
                question03: { q: 'Perchè dovrei sottopormi a questi test?' },
                question04: {
                    q: 'Come posso prepararmi per questi test?',
                    a:
                        'Puoi leggere tutto sui requisiti tecnici e su come prepararti ai test su <a href={link} target="_blank">questa pagina</a>. Lì troverai anche il materiale che ti aiuterà a superarli',
                },
                question05: {
                    q: 'Dopo posso trovare questi test in alternativa?',
                    a:
                        "In genere, potrebbe esserti chiesto di completare questi test dal tuo reclutatore - a parte questo, non li troverai disponibili per te da nessun'altra parte. Questa è un'opportunità esclusiva per te di fare pratica, scoprire di più su te stesso e sulla tua futura carriera.",
                },
                question06: {
                    q: 'Quante volte posso fare questi test?',
                    a:
                        'Puoi fare solo una prova per ogni test. Nessuna ripetizione! Assicurati di avere condizioni ottimali per fare il test per sfruttare al meglio questa opportunità. Puoi familiarizzare con il test guardando video screencast istruttivi e facendo una prova pratica prima di fare il test.',
                },
                question07: {
                    q: 'In quale lingua sono questi test?',
                    a:
                        "\n La lingua predefinita per questi test è l'inglese, tuttavia, ognuno di essi ha una varietà di lingue tra cui scegliere. Puoi controllare quali lingue sono disponibili e scegliere quella più adatta a te prima di fare il test. \n     ",
                },
                question08: {
                    q:
                        'Una volta pagato per i test completi devo completarli entro una certa data?',
                    a:
                        'No! Dopo che il tuo pagamento è stato accettato, puoi fare i test estesi quando vuoi. Prenditi il tuo tempo per prepararti e inizia le valutazioni nel momento in cui ti conviene.',
                },
            },
        },
        center: {
            banner: {
                title: 'Controlla il tuo progresso',
                subtitle: 'Ecco una panoramica dei tuoi progressi nelle valutazioni di carriera',
                moreInfo: 'Più informazioni',
                yourProgress: 'I tuoi progressi',
                quote:
                    'Stabilire degli obiettivi è il primo passo per trasformare l’invisibile in visibile',
            },
            list: {
                timeEstimated: 'approssimativamente. {minutes} minuti',
                freemium: {
                    intro:
                        '\n Questo è il primo passo nel tuo percorso di crescita personale! <br />\n Fai questi test per valutare i tuoi punti di forza e ottenere resoconti affidabili sulle tue capacità.\n    ',
                },
                premium: {
                    intro:
                        '\n Questo è un vero e proprio affare.<br/>\n Fai questi test per scoprire quali percorsi di carriera dovresti perseguire e ottieni un <strong>Rapporto Candidato</strong> completo.    \n',
                    description:
                        '\n Il tuo <strong>Rapporto Candidato</strong> ti darà una panoramica completa \n dei tuoi risultati, compresi <strong>consigli</strong> su come migliorare le tue \n abilità personali, a quali <strong>abilità</strong> dovresti prestare attenzione, le \n migliori <strong>opportunità</strong> per iniziare, quale dovrebbe essere il tuo \n<strong>passo successivo</strong>, e altro ancora.\n   ',
                },
            },
            instruments: {
                '344': {
                    name: 'Pensiero logico-deduttivo',
                    description:
                        'Scopri quanto sei bravo a usare la conoscenza e ad applicare le regole - questo test misura le tue capacità analitiche e di risoluzione dei problemi.',
                    estimatedTime: '9',
                },
                '383': {
                    name: 'Ragionamento logico-induttivo',
                    description:
                        'Quanto bene sai identificare le regole e le interrelazioni? Verifica con questo test che misura le tue capacità analitiche e di risoluzione dei problemi.',
                    estimatedTime: '9',
                },
                '390': {
                    name: 'Comportamento legato al lavoro',
                    description:
                        'Che tipo di caratteristiche di personalità da dipendente hai? Scoprilo facendo questo test che identifica le tue caratteristiche di personalità basate sul lavoro.',
                    estimatedTime: '30',
                },
                '721': {
                    name: 'Ragionamento numerico',
                    description:
                        'Quanto sei bravo con i numeri? Questo test misura la tua comprensione delle informazioni numeriche e il raggiungimento di conclusioni logiche',
                    estimatedTime: '9',
                },
                '5392': {
                    name: 'Memoria di lavoro',
                    description:
                        'Quanto bene riesci a rimanere concentrato? Questo test misura la capacità di elaborare e ricordare le informazioni in ambienti con distrazioni.',
                    estimatedTime: '15',
                },
                '82013': {
                    name: 'Test flessibile',
                    description:
                        'Quali sono i tuoi interessi? Questo questionario ti aiuterà a determinare quali percorsi di carriera potresti voler seguire.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Inizia le tue valutazioni Aon',
            consent:
                'Comprendo che Aon è responsabile dei miei dati relativi a questa valutazione e accetto i loro termini e condizioni.\n Accetto anche che Highered possa trasferire il mio nome ad Aon per generare il mio resoconto.',
            startTest: 'Inizia il test',
            consentErrorTitle: 'Errore nel processo di consenso',
            consentErrorMessage:
                "Qualcosa non ha funzionato durante l'invio del tuo consenso. Hai confermato la tua email?",
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats": {
        '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair': {
            " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire": {
                '"':
                    '\n                Recrutorii din întreaga lume folosesc Testele de Evaluare AON în procesul de selecție a candidaților. Completându-le înainte de interviu și prezentându-le rapoarte deja pregătite, veți avea o mare șansă de a uimi cu adevărat recrutorul. Cum? \n                <br><br>\n                În primul rând – veți veni pregătit cu o parte a procesului de recrutare deja realizat, care vă va face instant să săriți în fruntea altor canditați.\n                <br><br>\n                În al doilea rând – abordați recrutarea cu mintea limpede. Vă cunoașteți punctele forte și ceea ce vă rezervă viitorul - o infuzie de motivație instantanee și un spor de încredere garantat! Recrutorii își vor da seama de asta.',
            },
        },
    },
    calendar: {
        header: 'Calendario',
        myCalendar: 'Il mio calendario',
        noCalendar: 'Il tuo servizio carriera non ha ancora attivato la funzione calendario.',
        goBackBtn: 'Torna indietro',
        calendarNotReady:
            'La funzionalità “il mio calendario” non è ancora disponibile. Lo sarà presto!',
        noUpcomingAppointments: 'Non hai appuntamenti imminenti',
        appointmentMissing: 'Appuntamento non attivo',
        appointmentNotActive:
            'Spiacente, hai cercato di visualizzare un appuntamento inesistente o non attivo.',
        appointmentNotHavingAvailability:
            'Siamo spiacenti, questo appuntamento non è disponibile al momento. Controlla più tardi.',
        appointmentMissingRules: 'Non ci sono diponibilità per l’appuntamento',
        needToCompleteProfile: 'Completa il tuo profilo',
        noUpcomingAppointmentsPleaseBook: 'Prendi un appuntamento per sbloccare il tuo calendario',
        bookAppointment: 'Prendi un appuntamento',
        bookAnotherAppointment: 'Prendi un appuntamento',
        attendedAppointments: 'Appuntamenti a cui hai partecipato',
        aboutAppointments: {
            header: 'A proposito degli appuntamenti',
            button: 'A proposito',
            block1: {
                header: 'Cos è un appuntamento?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
            block2: {
                header: 'Chi posso contattare per avere più informazioni?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        },
        bookAnAppointment: 'Prendi un appuntamento',
        backToCalendarBtn: 'Ritorna al calendario',
        backToBookingBtn: 'Ritorna alla lista degli appuntamenti',
        firstAvailable: 'Il primo disponibile',
        loadingAppointment: 'Caricamento…',
        bookModal: {
            title: 'Conferma la prenotazione',
            with: 'Conferma la prenotazione',
            confirm: 'Conferma',
            continue: 'Continua',
            cancel: 'Chiudi',
            first: {
                title: 'Questo è il tuo primo appuntamento',
                description:
                    "Per assicurarti di ricevere l'invito all'evento, conferma di avere accesso a un calendario personale attraverso questo account e-mail",
                ok: 'OK',
                wrongEmail: 'Email sbagliata?',
            },
            changeEmail: {
                title: 'Seleziona l’email per il tuo calendario',
                inputPlaceholder: 'Inserisci l’email',
                ok: 'OK',
                back: 'Usa valore di default',
            },
            unknownErrorHeader: 'Si è verificato un errore durante la prenotazione',
            unknownErrorBody:
                'Per favore prova a fare un’altra prenotazione e se non va a buon fine, contatta l’assistenza',
            confirmationHeader: 'Il tuo appuntamento è stato prenotato!',
            bookedTheFollowing: 'Dettagli:',
            emailWillBeSent: 'Verrà spedita una email a',
            withConfirmation: 'richiedendoti di confermare la tua presenza',
        },
        dateDetailsModal: { title: 'Appuntamenti il' },
        completedYourProfile: 'Devi completare il tuo profilo per avere accesso ai calendari',
        toMyProfile: 'Modifica il mio profilo',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} vuole vedere il tuo profilo',
            content: 'Vuoi condividere il tuo profilo con questa persona?',
            share: 'Condividi il profilo',
            reject: 'No',
        },
    },
    companyDetail: {
        locations: {
            header: 'Luoghi',
            viewAll: 'Vedi tutte',
            noLocations: 'Nessun  luogo',
            allLocations: 'Tutti i luoghi',
        },
        jobModule: {
            header: 'Posizioni migliori',
            viewAllJobs: 'Vedi tutti gli impieghi di {companyName}',
            noPositions:
                '{companyName} al momento non ha nessuna posizione disponibile su Highered.',
            defaultLabel: 'Posizioni disponibili',
        },
        videos: {
            header: 'Video',
            noVideos: 'Nessun video',
            noMoreVideos: 'Nessun altro video',
            moreVideosFrom: 'Più video da {companyName}',
        },
        articles: {
            header: 'Articoli',
            noArticles: 'Nessun articolo',
            noMoreArticles: 'Nessun altro articolo',
            moreArticlesFrom: 'Nessun altro articolo da {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Crea' },
            yearMonthPicker: { defaultSelect: 'Seleziona mese' },
            localeDropdown: {
                languages: { en: 'Inglese', cn: 'Cinese', fr: 'Francese' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Verifica la tua email scolastica',
                description:
                    'È un processo rapido e ti darà accesso a\n caratteristiche esclusive come annunci di lavoro unici, test \n di abilità e risorse per la carriera.',
                verificationPending: 'Verifica in corso',
                weHaveSentAnEmail:
                    " Abbiamo inviato un'e-mail a \n<strong>{studenteEmail}</strong> affinché \n tu possa verificare da solo. Assicurati di \n controllare la tua cartella spam, dato che molte scuole sono \n abbastanza rigide sulle email in arrivo.",
                verifyMe: 'Verificami',
                resendVerifyEmail: 'Invia nuovamente l’email di verifica',
                cancelVerification: 'Annulla la verifica',
                emailSent: 'Email spedita',
                emailSentMessage:
                    "L'e-mail è stata inviata con successo. Se non la ricevi, contattaci a support@highered.global.",
                resendErrorTitle: 'Errore durante l’invio della email',
                resendErrorMessage:
                    "Non è stato possibile inviare nuovamente l'e-mail di verifica. Per favore, contattaci a support@highered.global",
                verificationCancelledTitle: 'Verifica annullata',
                verificationCancelledMessage: 'La verifica è stata annullata con successo.',
                cancelErrorTitle: 'Errore durante l’annullamento',
                cancelErrorMessage:
                    "Non è stato possibile annullare la verifica. Contattateci all'indirizzo support@highered.global.",
            },
            verifyModuleDialog: {
                title: 'Verifica la tua email scolastica',
                university: 'Istituzione Accademica',
                studentEmail: 'Indirizzo email della tua istituzione',
                studentEmailPlaceholder: 'Indirizzo dell’istituzione',
                message: 'Messaggio',
                verify: 'Verifica',
                sendRequest: 'Spedisci richiesta',
                verificationInProcess: 'Verifica in corso',
                emailHasBeenSentTo:
                    'Una email è stata inviata a <strong>{email}</strong>. Segui le istruzioni per verificare la tua posizione a <strong>{nome della scuola}</strong>.',
                verificationRequestSentNonAcademic:
                    'I servizi per la carriera di <strong>{schoolName}</strong> dovranno verificare la tua posizione. Sarai avvisato via e-mail quando ciò avverrà.',
                ifNoEmailRecieved: 'Se non hai ricevuto l’email di verifica, contattaci per favore',
                contactHelp: 'Contattaci se ti serve aiuto',
                doNotHaveAcademicEmail: 'Non ho una email accademica',
                doubleCheckEmail:
                    'Per favore, controlla che questo indirizzo e-mail sia corretto e che tu possa accedervi.',
                haveAcademicEmail: 'Ho una email accademica',
                noAcademicEmailInfo:
                    'Se non usi un indirizzo e-mail accademico, la tua richiesta dovrà essere approvata manualmente dai servizi per la carriera. Devi quindi inserire un breve messaggio per identificarti.',
                alreadyVerifiedInfo: 'Sei già stato verificato da questa scuola',
            },
        },
        navigation: {
            navigation: {
                myPage: 'La mia pagina',
                jobs: 'Impieghi',
                companies: 'Aziende',
                resources: 'Corsi di perfezionamento',
                assessments: 'Valutazioni',
                countryGuides: 'Guide nazionali',
                goToHaigui: 'Impieghi in Cina',
                signIn: 'Effettua il log-in / Registrati',
                vfairs: 'Eventi Virtuali',
                events: 'Eventi',
                newFeature: 'Nuova funzionalità!',
            },
            profileNavigation: { signOut: 'Esci' },
            sidebar: {
                myPage: 'La mia pagina',
                myProfile: 'Il mio profilo',
                findJobs: 'Trova impieghi',
                findCompanies: 'Trova aziende',
                resources: 'Corsi di perfezionamento',
                assessments: 'Valutazioni',
                countryGuides: 'Guide nazionali',
                goToHaigui: 'Impieghi in Cina',
                virtualFairs: 'Eventi Virtuali',
                logOut: 'Esci',
            },
            backToCalendar: 'Ritorna al calendario',
            allBooths: 'Tutti gli stand',
            home: 'Home',
        },
        smart: {
            companyModule: {
                followJob: 'Aggiungi ai preferiti',
                followCompany: 'Segui l’azienda',
                unFollowJob: 'Rimuovi dai preferiti',
                unFollowCompany: 'Non seguire più l’azienda',
                favoritedTitle: 'Salva nei preferiti',
                favoritedMessage:
                    'Questa posizione è stata salvata nei tuoi preferiti. Trova le tue posizioni preferite su La mia pagina.',
                unfavoritedTitle: 'Rimuovi dai preferiti',
                unfavoritedMessage: 'Questa posizione è stata rimossa dai tuoi preferiti. ',
                favoriteErrorTitle: 'Qualcosa non ha funzionato',
                favoriteErrorMessage:
                    'Non è stato possibile aggiungere questa posizione ai preferiti',
                showAllCompanies: 'Mostra tutte le aziende',
                showOnlyCompaniesLiveOnChat: 'Mostra solo le azienda online nella chat',
            },
            profileModule: {
                profileCompletion: 'Completamento del profilo',
                profileCompletionEncouragement:
                    "Mostrati ai datori di lavoro completando l'ultima {percentageLeft} del tuo profilo",
                gotoProfilePage: 'Aggiorna profilo',
                profileCompleted: 'Profilo completato',
                profileCompletedWhatsNext:
                    'Sapevi che la maggior parte dei datori di lavoro usa valutazioni online nei loro processi di selezione? Fai pratica ora e ottieni informazioni sui tuoi punti di forza e di debolezza.',
                gotoTestsPage: 'Vai al centro valutazioni',
                authIndication: {
                    title: 'Trova il tuo impiego dei sogni',
                    description:
                        'Vuoi accedere a posizioni che sono uniche per la tua scuola, e a test che potenzieranno la tua ricerca di impiego? Crea facilmente un account con Google, LinkedIn o Facebook oggi stesso.',
                    action: 'Partiamo',
                },
                toProfileHint: 'Al mio profilo',
                toProfileUncompletedHint:
                    'Il tuo profilo non è completo al 100%. Si prega di procedere completando al fine di massimizzare la tua possibilità di impiego.',
                profileActions: {
                    addFirstName: 'Aggiungi il nome di battesimo',
                    addLastName: 'Aggiungi il cognome',
                    addNationality: 'Aggiungi la nazionalità',
                    addPhoneNumber: 'Aggiungi il tuo numero di telefono',
                    addLanguage: 'Aggiungi una lingua',
                    addEducation: 'Aggiungi il titolo di studio',
                    addEmail: 'Aggiungi la tua email',
                    addGender: 'Aggiungi il tuo genere',
                },
            },
            featuredCompanies: { label: 'Aziende in primo piano' },
            featuredPositions: { label: 'Posizioni in primo piano' },
            featuredResource: {
                header: 'Unisciti alla conferenza virtuale',
                cta: 'Guardala adesso!',
                wechatSignupHeader: 'Segui l’account WeChat di Highered per ottenere aggiornamenti',
            },
        },
    },
    '"': '¡Escanee el código para ahora!',
    cts: {
        filterNames: {
            employment_types: 'Tipi di impiego',
            education_level: 'Diplomi',
            job_category: 'Campi',
            address: 'Luoghi',
            sector: 'Settori',
            exclude_school_id: 'Escludi',
            languages: 'Lingue',
        },
        excludeSchoolIds: {
            '-1': 'Condividi post',
            unknownSchoolId: 'Partner scolastici EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Lauree',
            MASTERS_OR_EQUIVALENT: 'Master',
            DOCTORAL_OR_EQUIVALENT: 'Dottorati',
            MBA_OR_EQUIVALENT: 'Master in gestione d’impresa',
            DBA_OR_EQUIVALENT: 'Dottorato in Business Administration ',
        },
        employmentTypes: {
            FULL_TIME: 'Tempo pieno',
            INTERN: 'Stage',
            TEMPORARY: 'Part time',
            PART_TIME: 'Part time',
        },
        startDate: 'Inizia',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Contabilità e finanza',
            ADMINISTRATIVE_AND_OFFICE: 'Amministrazione e ufficio',
            ADVERTISING_AND_MARKETING: 'Pubblicità e marketing',
            ART_FASHION_AND_DESIGN: 'Arte, moda e design',
            BUSINESS_OPERATIONS: 'Attività commerciali',
            COMPUTER_AND_IT: 'Computer e informatica',
            CUSTOMER_SERVICE: 'Assistenza clienti',
            EDUCATION: 'Educazione',
            HEALTHCARE: 'Sanità',
            HUMAN_RESOURCES: 'Risorse umane',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Installazione, manutenzione e riparazione',
            LEGAL: 'Legale',
            MANAGEMENT: 'Amministrazione',
            MANUFACTURING_AND_WAREHOUSE: 'Produzione e magazzino',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Comunicazione e redazione per i media',
            OIL_GAS_AND_MINING: 'Energia',
            PROTECTIVE_SERVICES: 'Servizi di protezione',
            REAL_ESTATE: 'Immobiliare',
            SALES_AND_RETAIL: 'Vendite e vendita al dettaglio',
            SCIENCE_AND_ENGINEERING: 'Scienze e ingegneria',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Servizi sociali e no profit',
            TRANSPORTATION_AND_LOGISTICS: 'Trasporti e logistica',
        },
        sectors: {
            Consulting: 'Consulenza',
            'Consumer Goods': 'Beni di consumo',
            'Financial Services / Banking': 'Servizi finanziari/bancari',
            'Goverment / Public Administration / Non Profit':
                'Governo / Pubblica Amministrazione / Non Profit',
            'International Trade & Development': 'Commercio internazionale e sviluppo',
            Manufacturing: 'Manifattura',
            'Media / Entertainment': 'Media / Intrattenimento',
            'Petroleum / Energy': 'Petrolio / Energia',
            'Pharma / Healthcare / Biotech': 'Farmaceutico / Sanitario / Biotecnologico',
            'Real Estate / Construction / Infrastructure':
                'Immobili / Costruzioni / Infrastrutture',
            'Technology (IT) / Telecom': 'Tecnologia (IT) / Telecom',
            'Transportations & Logistics': 'Trasporti e logistica',
            Other: 'Altro',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hong Kong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa & Africa Sub-Sahariana',
            'Hong Kong': 'Hong Kong',
            'Korea, South': 'Korea del sud',
            'New Zealand': 'Nuova Zelanda',
            'Papua-Ny Guinea': 'Papua Nuova Guinea',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Arabia Saudita',
            'South Africa': 'Sud Africa',
            'South Korea': 'Corea del Sud',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwan',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'Emirati Arabi Uniti',
            'United Kingdom': 'Regno Unito',
            'Ivory Coast': "Costa d'Avorio",
            Afghanistan: 'Afghanistan',
            Algeria: 'Algeria',
            Angola: 'Angola',
            Argentina: 'Argentina',
            Armenia: 'Armenia',
            Australia: 'Australia',
            Austria: 'Austria',
            Azerbaijan: 'Azerbaijan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrain',
            Bangladesh: 'Bangladesh',
            Belarus: 'Bielorussia',
            Belgium: 'Belgio',
            Botswana: 'Botswana',
            Brazil: 'Brasile',
            Bulgaria: 'Bulgaria',
            Cambodia: 'Cambogia',
            Canada: 'Canada',
            Chile: 'Cile',
            China: 'Cina',
            Colombia: 'Colombia',
            Congo: 'Congo',
            Croatia: 'Croazia',
            Cyprus: 'Cipro',
            Czechia: 'Cecoslovacchia',
            Denmark: 'Danimarca',
            Ecuador: 'Ecuador',
            Egypt: 'Egitto',
            Estonia: 'Estonia',
            Ethiopia: 'Ethiopia',
            Fiji: 'Fiji',
            Finland: 'Finlandia',
            France: 'Francia',
            Germany: 'Germania',
            Ghana: 'Ghana',
            Greece: 'Grecia',
            Guernsey: 'Guernsey',
            Hungary: 'Ungheria',
            Iceland: 'Islanda',
            India: 'India',
            Indonesia: 'Indonesia',
            Iraq: 'Iraq',
            Ireland: 'Irlanda',
            Israel: 'Israele',
            Italy: 'Italia',
            Japan: 'Giappone',
            Jersey: 'Jersey',
            Jordan: 'Giordania',
            Kazakhstan: 'Kazakistan',
            Kenya: 'Kenya',
            Kuwait: 'Kuwait',
            Laos: 'Laos',
            Latvia: 'Lettonia',
            Lebanon: 'Libano',
            Lithuania: 'Lituania',
            Luxembourg: 'Lussemburgo',
            Malaysia: 'Malesia',
            Malta: 'Malta',
            Mauritania: 'Mauritania',
            Mauritius: 'Mauritius',
            Mexico: 'Messico',
            Mongolia: 'Mongolia',
            Morocco: 'Marocco',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Netherlands: 'Paesi Bassi',
            Nigeria: 'Nigeria',
            Norway: 'Norvegia',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Filippine',
            Poland: 'Polonia',
            Portugal: 'Portogallo',
            Qatar: 'Qatar',
            Romania: 'Romania',
            Russia: 'Russia',
            Senegal: 'Senegal',
            Serbia: 'Serbia',
            Singapore: 'Singapore',
            Slovakia: 'Slovacchia',
            Slovenia: 'Slovenia',
            Spain: 'Spagna',
            Sudan: 'Sudan',
            Swaziland: 'Swaziland',
            Sweden: 'Svezia',
            Switzerland: 'Svizzera',
            Syria: 'Siria',
            Taiwan: 'Taiwan',
            Tanzania: 'Tanzania',
            Thailand: 'Thailandia',
            Tonga: 'Tonga',
            Turkey: 'Turchia',
            Ukraina: 'Ucraina',
            Ukraine: 'Ucraina',
            USA: 'USA',
            Uzbekistan: 'Uzbekistan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Zambia',
        },
        languages: {
            Aceh: 'Aceh',
            Afrikaans: 'Afrikaans',
            Albanian: 'Albanese',
            Amharic: 'Amarico',
            Arabic: 'Arabo',
            Arakanese: 'Arakanese',
            Armenian: 'Armeno',
            Azeri: 'Azero',
            Badini: 'Badini',
            Basque: 'Basco',
            Belarusian: 'Bielorusso',
            Bengali: 'Bengalese',
            Berber: 'Berbero',
            Bosnian: 'Bosniaco',
            Bulgarian: 'Bulgaro',
            Burmese: 'Birmano',
            Cantonese: 'Cantonese',
            Catalan: 'Catalano',
            Cebuano: 'Cebuano',
            Chechen: 'Ceceno',
            Chin: 'Chin',
            Chinese: 'Cinese',
            Croatian: 'Croato',
            Czech: 'Ceco',
            Danish: 'Danese',
            Dari: 'Dari',
            Dutch: 'Olandese',
            English: 'Inglese',
            Estonian: 'Estone',
            Faroese: 'Faroese',
            Filipino: 'Filippino',
            Finnish: 'Finlandese',
            French: 'Francese',
            German: 'Tedesco',
            Greek: 'Greco',
            Greenlandic: 'Groenlandese',
            Hausa: 'Hausa',
            Hebrew: 'Ebraico',
            Hindi: 'Hindi',
            Hungarian: 'Ungherese',
            Icelandic: 'Islandese',
            Indonesian: 'Indonesiano',
            Italian: 'Italiano',
            Japanese: 'Giapponese',
            Kazakh: 'Kazako',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Coreano',
            Kurdish: 'Curdo',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latino',
            Latvian: 'Lettone',
            Lingala: 'Lingala',
            Lithuanian: 'Lituano',
            Macedonian: 'Macedone',
            Malagasy: 'Malgascio',
            Malaysian: 'Malese',
            Mandarin: 'Mandarino',
            Mongolian: 'Mongolo',
            Nepali: 'Nepali',
            Norwegian: 'Norvegese',
            Oromo: 'Oromo',
            Other: 'Altro',
            Panjabi: 'Panjabi',
            Pashto: 'Pashto',
            Persian: 'Persiano',
            Polish: 'Polacco',
            Portuguese: 'Portoghese',
            Punjabi: 'Punjabi',
            Romanes: 'Romanes',
            Romani: 'Romani',
            Romanian: 'Rumeno',
            Russian: 'Russo',
            Sami: 'Sami',
            Serbian: 'Serbo',
            Sign_language: 'Lingua dei segni',
            Slovak: 'Slovacco',
            Slovene: 'Sloveno',
            Somali: 'Somalo',
            Sorani: 'Sorani',
            Spanish: 'Spagnolo',
            Swahili: 'Swahili',
            Swedish: 'Svedese',
            Tagalog: 'Tagalog',
            Tamil: 'Tamil',
            Thai: 'Thai',
            Tigrinya: 'Tigrino',
            Turkish: 'Turco',
            Ukrainian: 'Ucraino',
            Urdu: 'Urdu',
            Uyghur: 'Uyghur',
            Vietnamese: 'Vietnamita',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Verifica email',
        verifyingEmail: 'Processo verifica email',
        emailVerifySuccess: 'La tua email è stata verificata',
        emailVerifyFailure: 'Qualcosa non ha funzionato… riprova più tardi o contatta il supporto',
        gotoMyPage: 'Ritorna alla Mia Pagina',
    },
    errors: {
        defaultErrorMessage: 'Qualcosa non ha funzionato!',
        logInErrorText: {
            invalidCredentials: 'Password o nome utente errati',
            inactiveUser:
                "L'utente con l'email fornita è inattivo. Controlla la tua email per l'attivazione dell'account o prova a resettare la tua password.",
            default: 'Impossibile fare l’autenticazione',
        },
        registerErrorText: {
            passwordTooShort: 'La password deve contenere almeno 8 caratteri',
            emailAlreadyInUse: 'L’email fornita è già in uso',
            emailTaken:
                "L'email è già in uso. Se hai usato l'email della tua scuola, questo potrebbe accadere perché avevi un account prima che la piattaforma fosse aggiornata (su higheredtalent.org).",
            default: 'Impossibile creare un utente',
        },
        invalidTokenText: { default: 'Il tuo token non è valido o è scaduto' },
        passwordErrorText: {
            passwordTooShort: 'La password deve contenere almeno 8 caratteri',
            requireNonAlphanumeric: 'La password deve contenere almeno un carattere speciale',
            requireLowerCase: 'La password deve contenere almeno una lettera minuscola',
            requireUpperCase: 'La password deve contenere almeno una lettera maiuscola',
            requireUniqueChars: 'La password deve contenere almeno 6 caratteri diversi',
            default: 'Impossibile cambiare la password',
        },
        recoverErrorText: {
            userNotFound: 'L’utente non esiste! Per favore contattare il supporto',
            userAlreadyActive: 'L’utente è già stato attivato! Per favore effettuare il log-in',
            emailAlreadyInUse:
                "L'email fornita è già in uso.\n Se vuoi procedere con l'attivazione dell'account, prova un'altra email o un altro social login. Altrimenti, vai alla home page e accedi al tuo account.",
            default: "Non è stato possibile attivare l'account \n Si prega di riprovare più tardi.",
        },
        socialAuthErrorText: {
            errorTitle: 'Non è stato possibile accedere con {provider}',
            invalidProviderGoogle:
                "L'utente con l'email fornita non è connesso a Google. Si prega di provare ad esempio ad accedere con LinkedIn, Facebook o con l'e-mail.",
            invalidProviderFacebook:
                "L'utente con l'email fornita non è connesso a Facebook. Si prega di provare ad esempio ad accedere con Google, LinkedIn, o con l'e-mail.",
            invalidProviderLinkedIn:
                "L'utente con l'email fornita non è connesso a LinkedIn. Si prega di provare ad esempio ad accedere con Google, Facebook o con l'e-mail.",
            invalidProviderWeChat:
                "L'utente con l'email fornita non è connesso a WeChat. Si prega di provare ad esempio ad accedere con Google, Facebook o con l'email.",
        },
        uniConnErrorText: {
            emailNotAvailable:
                "L'email che hai fornito è già in uso. Questo potrebbe essere dovuto al fatto che avevi un account prima che la piattaforma fosse aggiornata (su higheredtalent.org). Per favore contatta il supporto.",
            invalidEmailDomain:
                "Il dominio e-mail fornito non corrisponde all'università indicata. Si prega di scegliere l'università corretta.",
            existingConnection: 'Questo utente è già connesso con l’università indicata',
            default: 'Non è stato possibile iniziare il processo di verifica',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'L’email fornita è già in uso',
                default: 'Non è stato possibile fare l’aggiornamento',
            },
        },
    },
    favorites: {
        header: 'I miei preferiti',
        active: 'Attivo',
        expired: 'Scaduto',
        expiresThisMonth: 'Scadenza della domanda questo mese',
        expiresThisWeek: 'Scadenza della domanda questa settimana',
        expiresLater: 'Scadenza della domanda più tardi',
        noActiveFavorites: 'Non hai posizioni preferite attive',
        noExpired: 'Non hai posizioni preferite scadute',
    },
    findcompanies: { headerLabel: 'Trova aziende', companyListLabel: 'Aziende' },
    findjobs: {
        header: 'Trova impieghi',
        changeFilters: 'Cambia i filtri',
        recruitmentModule: {
            body:
                'Sei un responsabile del personale, un professionista dell’orientamento professionale o \n sei interessato ad assumere studenti di talento?',
            createJob: 'Clicca qui per creare un messaggio per l’impiego',
        },
    },
    general: {
        documentTitle: 'Piattaforma Opportunità Globali',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Conferma la password',
        loading: 'Caricamento',
        ok: 'OK',
        save: 'Salva',
        add: 'Aggiungi',
        close: 'Chiudi',
        delete: 'Cancella',
        cancel: 'Elimina',
        done: 'Fatto',
        continue: 'Continua',
        back: 'Indietro',
        next: 'Prossimo',
        finish: 'Termina',
        success: 'Con successo',
        error: 'Errore',
        description: 'Descrizione',
        months: {
            '0': 'Gen',
            '1': 'Feb',
            '2': 'Mar',
            '3': 'Apr',
            '4': 'Mag',
            '5': 'Giu',
            '6': 'Lug',
            '7': 'Ago',
            '8': 'Sett',
            '9': 'Ott',
            '10': 'Nov',
            '11': 'Dic',
        },
        days: {
            '0': 'Dom',
            '1': 'Lun',
            '2': 'Mar',
            '3': 'Mer',
            '4': 'Gio',
            '5': 'Ven',
            '6': 'Sab',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Controllo della verifica in corso',
                verifySchoolConnection:
                    'Verifica la tua connessione con la scuola per accedere a queste risorse',
                logInToAccessMoreFeatures:
                    'Migliaia di opportunità per una carriera internazionale',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Offerto da',
    },
    gptw: {
        company: {
            alt: 'PPPL',
            tooltip: 'Questa azienda è certificata come “Posto Perfetto Per Lavorare”.',
        },
        posting: {
            label: {
                alt: 'PPPL',
                tooltip: 'Questo messaggio appartiene a un’azienda  “Posto Perfetto Per Lavorare”.',
            },
            detail: {
                alt: 'PPPL',
                tooltip: {
                    isCertified:
                        ' {companyName}  è certificata come “Posto Perfetto Per Lavorare”.',
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                    readMore: 'Clicca per leggere di più',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Scadenza della domanda ',
            location: 'Luogo',
            employmentType: 'Tipo di impiego',
            languageRequirements: 'Requisiti linguistici',
            workPermitRequirements: 'Requisiti permesso di lavoro',
            preferredEducationField: 'Campo di studio preferito',
            preferredEducationLevel: 'Livello di istruzione preferito',
            jobTags: 'Tags',
            apply: 'Fai domanda ora',
            verificationRequired: 'Devi verificare la tua email scolastica per fare domanda',
            verificationRequiredHint: 'Devi verificare la tua email scolastica per fare domanda',
            verificationPending: 'C’è una verifica in corso per questa scuola',
            verificationPendingHint: 'C’è una verifica in corso per questa scuola',
        },
        invalidJobAd: {
            caption:
                'Siamo spiacenti, ma non siamo riusciti a trovare questa posizione. Se credi che questo sia un errore, contatta il supporto usando la chatbox qui sotto.',
            btn: 'Trova altri impieghi',
        },
    },
    mypage: {
        header: 'La mia pagina',
        suggestedPositions: 'Posizioni suggerite',
        favoriteModule: {
            header: 'Le mie posizioni preferite',
            seeAll: 'Vedi tutte',
            noFavorites: 'Non hai posizioni preferite attive',
        },
    },
    recoverpassword: {
        createPassword: 'Crea una nuova password',
        newPasswordLabel: 'Nuova password',
        newPasswordPlaceholder: 'Password',
        confirmPasswordLabel: 'Conferma la password',
        confirmPasswordPlaceholder: 'Conferma la password',
        resetPasswordButton: 'Resetta la password',
        resettingPassword: 'Sto resettando la password',
        passwordsNotMatching: 'Le password non coincidono',
    },
    recoveruser: {
        headerLabel: 'Recupera utente Highered',
        accountActivation: 'Attivazione account',
        step1: {
            header: 'Benvenuto alla nostra nuova piattaforma',
            subHeader: 'Scegli come vuoi connetterti al tuo account',
            description:
                'Per un processo di login più semplice, ti consigliamo di collegare il tuo account ad almeno uno dei seguenti servizi.',
            OR: 'oppure',
            emailAndPassword: 'Usa la tua email personale',
        },
        step2: {
            header: 'Usa email e password',
            description:
                "Questa è l'email principale che sarà associata al tuo account. Ti consigliamo di usare un'email diversa dal tuo indirizzo universitario per mantenere l'accesso ai tuoi dati dopo la laurea. Puoi controllare facilmente quali email riceverai da noi nelle impostazioni del tuo account.",
            invalidEmail: 'L’email fornita non è valida',
            passwordsNotMatch: 'Le password devono coincidere',
            passwordDescription01:
                'Per garantire la sicurezza del tuo account è necessario impostare una nuova password. Si prega di creare una password con le seguenti caratteristiche:',
            passwordDescription02: 'Minimo di 8 caratteri',
            passwordDescription03: 'Almeno una lettera minuscola (a-z)',
            passwordDescription04: 'Almeno una lettera maiuscola (A-Z)',
            passwordDescription05: 'Almeno un numero o un carattere speciale (0-9, !#$ etc)',
            passwordDescription06: 'Almeno 6 caratteri diversi',
            repeatPassword: 'Digita nuovamente la password',
        },
        step3: {
            header: 'Attivazione utente',
            loadingHints: {
                '0': 'Caricamento dati utente',
                '1': 'Stiamo preparando tutto',
                '2': 'Nuove opportunità dietro l’angolo',
                '3': 'Quasi finito!',
            },
            successHeader: 'Ora il tuo account è pronto!',
            successSubheader: 'Adesso hai accetto a contenuti esclusivi!',
            errorHeader: 'Non è stato possibile attivare il tuo account',
            ifWrongContact: 'Se pensi ci sia un errore, contatta il servizio clienti',
            contactForHelp: 'Contattaci se ti serve aiuto',
            goBack: 'Indietro',
        },
    },
    resourcesInternal: {
        header: 'Risorse',
        resourceTypeHeader: 'Tipo',
        resourceNoContent: 'La tua scuola non ha ancora attivato la funzione risorse',
        resourceFolderNoContent: 'Non ci sono risorse disponibili in questa cartella',
        resourceTitleHeader: 'Titolo',
        resourcePublishDateHeader: 'Pubblicato',
        searchPlaceholder: 'Ricerca per nome o parola chiave…',
        cvTemplateHeader: 'MODELLO DI CV HIGHERED (ATS-FRIENDLY)',
        cvTemplateSubtitle: 'Scaricalo qui!',
    },
    shared: {
        userNavSection: {
            myPage: 'La mia pagina',
            myProfile: 'Il mio profilo',
            myTests: 'Valutazioni',
            myApplications: 'Applicazioni',
            myFavorites: 'Preferiti',
            internalResources: 'Risorse',
            calendar: 'Calendario',
            documents: 'Carica CV',
        },
        searchModule: {
            searchBar: { label: 'Ricerca per titolo o parola chiave…' },
            filters: { clearFilters: 'Azzera filtri' },
            filterLimit: {
                title: 'Raggiunto limite di filtri',
                message: 'Non si possono selezionare altri filtri di questo tipo',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Posizioni',
                estimatedCount: 'ca {count} di {totalCount}',
                knownCount: '{count} di {totalCount}',
                noMatchFound: 'Non è stato trovato niente che corrisponda ai tuoi criteri',
            },
            postItem: { applyBefore: 'Scadenza della domanda ' },
            postCard: { deadline: 'Scandenza' },
        },
        loginModule: {
            emailVerificationTip: 'Ci possono volere alcuni minuti per riceverla nella tua inbox',
            noEmail: 'Nessuna email? Per favore controlla la tua cartella spam oppure:',
            logIn: 'Log in',
            socialAuthBtns: {
                continueWithFacebook: 'Continua con Facebook',
                continueWithGoogle: 'Continua con Google',
                continueWithLinkedIn: 'Continua con LinkedIn',
                continueWithWeChat: 'Continua con WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Per favore verifica la tua email',
                weSentAnEmailTo: 'Abbiamo spedito una verifica a',
                continueToSignIn: 'Continua per fare l’accesso',
                resendEmail: 'Rispedisci il link di verifica',
                newEmailSent: 'Nuova email spedita',
            },
            registerForm: {
                recommendation:
                    'Ti raccomandiamo di usare la tua email personale e non quella \n della scuola per assicurarti di avere accesso ai tuoi dati dopo il diploma.',
                register: 'Registra',
                passwordsNotMatch: 'Le password non coincidono',
            },
            logInPaper: {
                useEmail: 'oppure usa la tua email',
                noAccount: 'Non hai un account?',
                signUp: 'Registrati',
                logInToAccess: 'Fai il log-in per avere accesso a questa funzione',
                showAllOptions: 'Mostra tutte le opzioni di log-in',
                hideAllOptions: 'Mostra meno',
            },
            logInForm: {
                logIn: 'Log in',
                forgotPassword: 'Dimenticato la password?',
            },
            forgotPassword: {
                title: 'Richiedi reset della password',
                description:
                    'Non preoccuparti - tutti dimenticano la loro password di tanto in tanto.\n Inserisci la tua email qui sotto per reimpostare la tua password',
                resetPassword: 'Resetta la password',
                emailSentTitle: 'Ti stiamo aiutando!',
                emailHasBeenSent:
                    'Una email è stata inviata a\n <br> \n<strong>{email}</strong>\n <br>\n con le istruzioni su come reimpostare la tua password. Per favore controlla la tua casella\n di posta.',
                noEmail: 'Nessuna email?',
                sendEmailOneMoreTime: 'Rispedisci l’email',
                resendErrorTitle: 'Errore durante il recupero della password',
                resendErrorMessage:
                    'Impossibile spedire l’email per il recupero della password. Forse l’email è sbagliata?',
            },
        },
        universityBadges: {
            addAnotherUniversity: 'Aggiungi un’altra università',
            verificationDialog: {
                verifiedStudent: 'Studente {schoolAbbr} verificato',
                verificationDescription:
                    'Sei uno studente {schoolAbbr} verificato con email {email}',
                verificationDescriptionNoEmail: 'Sei uno studente {schoolAbbr} verificato',
                checkYourEmail: 'Verifica la tua email {schoolAbbr}.',
                sentEmailDescription:
                    "Ti abbiamo inviato un'email riguardante la verifica per {scuolaAbbr} a {email}. Per favore controlla la tua email.",
                resendEmail: 'Rispedisci l’email',
                cancelVerification: 'Annulla la verifica',
                notYetVerified: 'Affiliazione all’università non ancora verificata',
                verifyYourAffiliation:
                    'Per accedere a funzioni specifiche di {schoolAbbr} come annunci di lavoro e risorse esclusive, verifica la tua affiliazione.',
                verify: 'Verifica',
                goToPlatform: 'Vai alla piattaforma',
                verificationPending: 'Verifica in corso',
                verificationPendingDescription:
                    'I servizi per la carriera di {schoolAbbr} stanno verificando la tua richiesta. Sarai contattato via email quando la verifica sarà terminata.',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: 'Studente {uniSubDomain} verificato',
                    verifiedStudentWithEmail:
                        'Sei uno studente {uniSubDomain} verificato con email {email}',
                    checkEmail: 'Verifica la tua email {uniSubDomain}.',
                    sentEmailInfo:
                        "Ti abbiamo inviato un'email riguardante la verifica per {uniSubDomain} a {email}. Per favore controlla la tua email. ",
                    resendEmail: 'Rispedisci l’email',
                    cancelVerification: 'Annulla la verifica',
                    notYetVerified: 'Affiliazione all’università non ancora verificata',
                    resourceAccessInfo:
                        'Per accedere a funzioni specifiche di {uniSubDomain} come annunci di lavoro e risorse esclusive, verifica la tua affiliazione.',
                    verificationCancelled: 'Verifica annullata',
                    emailSent: 'Email spedita',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: 'Termini & condizioni',
            privacyPolicy: 'Informativa sulla privacy',
            talentPanel: 'Scuola/Datore di lavoro?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Cancellato',
                deletedTitle: 'Questa posizione non è più disponibile',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Sembra che la pagina che stai cercando non esista più',
            goToHome: 'Vai alla home page',
            contactus: 'Contattaci',
        },
        chat: {
            liveNow: 'Online sulla chat adesso!',
            seeAll: 'Tutti',
            schoolSpecificChats: 'Accesso rapido',
            help: 'Ti serve aiuto?',
            chatExistsLabel: 'La chat esiste',
        },
        countdown: {
            day: 'giorno',
            days: 'giorni',
            hour: 'ora',
            hours: 'ore',
            minute: 'minuto',
            minutes: 'minuti',
            second: 'secondo',
            seconds: 'secondi',
        },
    },
    spotlight: {
        header: 'Il mio profilo',
        saveChangesToSubmit: 'Salva il profilo per abilitare le modifiche',
        saveChanges: 'Salva le modifiche',
        saveSuccessful: 'Le tue modifiche sono state salvate con successo',
        personalDetails: {
            header: 'Informazioni personali',
            firstName: 'Nome di battesimo',
            lastName: 'Cognome',
            nationality: 'Nazionalità',
            gender: 'Genere',
            uploadProfileImage: 'Carica una fotografia',
            genderOptions: {
                male: 'Uomo',
                female: 'Donna',
                other: 'Altro',
                none: 'Preferisco non specificare',
                unknown: 'Sconosciuto',
            },
            wrongFileTypeErrorHeader: 'Tipo di file non valido',
            wrongFileTypeErrorDescription: 'Puoi caricare solo immagini',
        },
        summary: { header: 'Riassunto esecutivo' },
        contactDetails: {
            header: 'Informazioni contatto',
            contactEmail: 'Email contatto',
            phoneNumberHeader: 'Numero di cellulare',
            countryCode: 'Codice nazione',
            phoneNumber: 'Numero di telefono',
            invalidEmail: 'L’email inserita non è valida',
            permanentEmail:
                'NOTA: Questa operazione è definitiva. Puoi inserire la tua email solo una volta',
        },
        languages: {
            header: 'Lingue',
            languageLabel: 'Lingua',
            levelLabel: 'Livello',
            addLanguage: 'Aggiungi una lingua',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Competenza elementare',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Competenza limitata a livello lavorativo',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63':
                    'Competenza professionale a livello lavorativo',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Competenza elevata a livello lavorativo',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Competenza come madrelingua o bilingue',
            },
        },
        education: {
            header: 'Titolo di studio',
            addEducation: 'Aggiungi titolo di studio',
            notGraduated: 'Non ancora diplomato',
            graduatedIn: 'Diplomato il {date} ',
            dialog: {
                addNewEducation: 'Aggiungi nuovo titolo',
                degreeTitle: 'Programma',
                institution: 'Istituzione',
                degreeType: 'Diploma',
                fieldOfStudy: 'Campo di studio',
                cannotFindField: 'Non trovo il mio campo',
                studyStart: 'Inizia mese',
                studyEnd: 'Mese di diploma',
                invalidDegreeTitle: 'Devi inserire un titolo per il tuo programma',
                invalidSchool: 'Devi selezionare una scuola',
                invalidStartDate: 'Per favore seleziona una data d’inizio',
                invalidEndDate: 'Per favore seleziona una data di diploma',
                invalidStudyPeriod: 'Non puoi diplomarti prima della data d’inizio',
                invalidDegreeField: 'Per favore inserisci una campo di studio valido',
                invalidDegreeLevel: 'Per favore inserisci una grado di diploma valido',
                selectStartDate: 'Data d’inizio',
                selectEndDate: 'Data di diploma',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Laurea',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Master',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'Master in gestione d’impresa',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'Dottorato in Business Administration ',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'Dottorati',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Agricoltura e foreste',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Scienze e professioni applicate',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Arte, design e architettura',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Business & Gestione',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Informatica & IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economia',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Istruzione e formazione',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Ingegneria e tecnologia',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Environmental Studies & Earth Sciences',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Hospitality, Leisure & Sports',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Scienze umane',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Giornalismo & Media',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Giurisprudenza',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': 'Master in Innovazione e Business',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Master in Development Management',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Master in Scienza dei Dati',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medicina e salute',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'Master in Finanza',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4': 'Master in Business Internazionale',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'Master in Analisi Aziendale',
                    '7d832109-642a-4730-aada-26927eb683ee': 'Master in Gestione',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Scienze naturali e matematica',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Scienze sociali',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Altro',
                },
            },
        },
        workAuthorization: {
            header: 'Autorizzazione al lavoro',
            addWorkAuthorization: "Aggiungi l'autorizzazione al lavoro",
            implicitValue: 'In base alla tua nazionalità',
            dialog: {
                selectCountry: 'Seleziona il paese',
                addEuWorkAuthorization: 'Aggiungi il permesso di lavoro UE',
            },
        },
        communication: {
            header: 'Comunicazione',
            sendMeUpdatesDescription:
                "Per favore, inviatemi notizie sulla carriera, posizioni e aggiornamenti dell'azienda via e-mail",
        },
        errors: {
            imageUpload: {
                title: "Impossibile caricare l'immagine.",
                message: "L'immagine è troppo grande!",
            },
        },
        exitDialog: {
            title: 'Le modifiche non salvate saranno perse',
            message:
                'Stai cercando di uscire dalla pagina senza salvare le tue modifiche. Vuoi salvare il tuo profilo prima di andare avanti?',
            stayAction: 'Rimani sulla pagina',
            saveAction: 'Salva il profilo',
            continueAction: 'Continua senza salvare',
        },
    },
    tests: {
        header: 'Test',
        unauthorized:
            'I test sono attualmente in beta limitata. Non hai ancora accesso a queste funzioni. Saranno disponibili presto!',
        error:
            'Qualcosa è andato storto quando hai provato a caricare i test. Si prega di riprovare più tardi.',
        assessmentModule: { header: 'La tua valutazione' },
        completedYourProfile:
            'Devi completare il tuo profilo per avere accesso a questa valutazione',
        toMyProfile: 'Modifica il mio profilo',
    },
    vfair: {
        header: 'Eventi virtuali EFMD',
        activeNow: 'In corso',
        visibilityPrivate: 'Privato',
        visibilityNetwork: 'Rete',
        visibilityOpen: 'Aperto',
        interested: 'Registrati',
        attend: 'Partecipa ad un evento',
        enterEvent: 'Prendi parte all’evento',
        notinterested: 'Non sono più interessato',
        shownInterest: 'Registrato',
        signUpToday: 'Registrati oggi!',
        vfairsInfo:
            "Connettiti con aziende e organizzazioni di tutto il mondo, in un sofisticato ambiente di simulazione di fiere del lavoro che permette l'interazione in tempo reale tra reclutatori e candidati. Clicca sull'evento virtuale che ti interessa e iscriviti per ricevere le notifiche.",
        recruitingOrgs: 'Aziende e organizzazioni di reclutamento',
        preRegistered: 'Pre registrato',
        prepareForTheFair: 'Preparati per l’evento virtuale',
        privateVFairHeader: 'Evento virtuale del campus',
        privateVFairMessage:
            'Questo evento virtuale è ospitato su una piattaforma della scuola EFMD e quindi non è possibile accedervi da qui.',
        schoolNotJoinedNetworkEventMessage:
            'La tua scuola non si è ancora iscritta a questo evento virtuale, contatta il tuo direttore di programma o il dipartimento delle carriere per chiedere la partecipazione.',
        companyNotJoinedNetworkEventMessage:
            'La tua organizzazione non ha uno stand virtuale attivo a questo evento. Contatta Highered per chiedere la partecipazione.',
        pavilions: 'Padiglioni',
        general: 'Generale',
        allCompanies: 'Tutte le aziende',
        lobby: 'Ingresso',
        inviteCode: 'Codice invito',
        eventRequiresInvitation: 'Questo evento richiede un invito',
        haveCode: 'Ho un codice',
        checkCode: 'Controlla il mio codice',
        invalidCode: 'Codice non valido',
        registeredSuccessfully: 'Registrato con successo',
        pavilionTabs: {
            home: 'Home',
            companies: 'aziende',
            articles: 'articoli',
            jobs: 'impieghi',
            events: 'eventi',
        },
        events: {
            noEventsAvailable: 'Nessun evento disponibile',
            showCompleted: 'Mostra completati',
            hideCompleted: 'Nascondi completati',
            liveNow: 'In diretta',
            joinTheEvent: 'Unisciti all’evento',
            addToCalendar: 'Aggiungi al calendario',
        },
        links: {
            masterclasses: {
                header: 'Corsi di perfezionamento',
                buttonCaption: 'Guarda i corsi di perfezionamento',
                description:
                    'Guarda una vasta gamma di corsi di perfezionamento di alta qualità, tra cui "Ottimizzazione del CV per essere assunti", "Il tuo profilo Linkedin" e "Negoziazione del salario", tra molti altri, per tutte le fasi del tuo percorso lavorativo',
            },
            detailsmasterclass: { header: 'Partecipa ai corsi di perfezionamento' },
            cv: {
                header: 'Modello CV',
                buttonCaption: 'Scarica modello CV',
                description:
                    "Accedi al modello di CV Highered ATS-friendly per fare un'ottima impressione professionale con i reclutatori.",
            },
            elevatorPitch: {
                header: 'Sfida miglioramento della presentazione',
                buttonCaption: 'Invia la tua presentazione',
                description:
                    'Accetta la "Pitch Perfect Challenge"! Questa è la tua opportunità di presentare il tuo talento a centinaia di reclutatori delle migliori aziende e organizzazioni mondiali',
            },
        },
        footerHeaders: {
            social: 'Seguici per avere aggiornamenti',
            sponsored: 'Sponsorizzato da',
            organized: 'Organizzato da',
        },
        educationPopup: {
            step00: {
                header: 'Condividi la tua istruzione',
                subtitle: 'Per continuare, lascia che i datori di lavoro sappiano di più di te',
                continueLabel: 'Aggiungi i miei titoli di studio',
                leaveLabel: 'Ignora',
            },
            step01: { header: 'Informaci sulla tua istruzione' },
            step02: { loadingLabel: 'Attendi un attimo…' },
            step03: {
                header: 'Titoli di studio completati',
                subtitle:
                    'Ora puoi condividere il tuo profilo ed essere più interessante per i datori di lavoro',
                continueLabel: 'Continua ad esplorare l’evento virtuale',
            },
            error: {
                header: 'Ops! Qualcosa è andato storto!',
                subtitle:
                    "Non siamo stati in grado di memorizzare le tue informazioni relative all'istruzione. Si prega di riprovare più tardi.",
            },
        },
    },
};
